import gql from 'graphql-tag';
const SPACEBAR_ACTIVITY_FRAGMENT = gql `
  fragment SpacebarActivityFragment on SpacebarActivity {
    rounds {
      roundIndex
      steps {
        stepIndex
        answer
        imagePath
        isToBeTyped
      }
    }
  }
`;
export default SPACEBAR_ACTIVITY_FRAGMENT;
